// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-coach-tables-dialog__backdrop {
  z-index: 1350;
  align-items: stretch;
  justify-content: center;
  padding: 8px;
  padding-bottom: var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));
  box-sizing: border-box;
}

/* Above session results (9999), nested exercise sheet (10050), change-exercise (16000). */
.lt-coach-tables-dialog__backdrop--elevated {
  z-index: 16100;
  padding-bottom: max(8px, env(safe-area-inset-bottom, 0px));
}

.lt-coach-tables-dialog.lt-table-wizard {
  position: relative;
  width: min(560px, 100%);
  max-width: 100%;
  max-height: none;
  /* Prefer visual-viewport height used by immersive live training. */
  height: calc(
    var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 16px -
      env(safe-area-inset-top, 0px)
  );
  max-height: calc(
    var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 16px -
      env(safe-area-inset-top, 0px)
  );
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.lt-coach-tables-dialog--multi-col.lt-table-wizard {
  width: min(920px, 100%);
}

.lt-coach-tables-dialog .lt-table-wizard__body {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
  padding: 8px 12px 6px;
}

.lt-coach-tables-dialog__header {
  align-items: flex-start;
  padding: 10px 12px 6px;
  flex-shrink: 0;
  gap: 6px;
  flex-wrap: nowrap;
  position: relative;
  border-bottom: 1px solid
    color-mix(in srgb, var(--lt-brand, #0877bc) 18%, rgba(255, 255, 255, 0.08));
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--lt-brand, #0877bc) 10%, rgba(15, 23, 42, 0.6)) 0%,
    transparent 100%
  );
}

.lt-coach-tables-dialog__header-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lt-coach-tables-dialog__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-wrap: nowrap;
}

.lt-coach-tables-dialog__title-row h2 {
  margin: 0;
  font-size: 1rem;
  font-weight: 750;
  letter-spacing: -0.01em;
  line-height: 1.25;
  color: #f8fafc;
  flex: 1 1 auto;
  min-width: 0;
}

.lt-coach-tables-dialog__club-logo {
  flex-shrink: 0;
}

.lt-coach-tables-dialog__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 2px;
  padding-left: 0;
}

.lt-coach-tables-dialog__stats--below {
  margin-top: 0;
  margin-left: 0;
  padding-left: 0;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.lt-coach-tables-dialog__body {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  min-height: 0;
  animation: lt-coach-tables-station-in 0.22s ease;
}

.lt-coach-tables-dialog__body--switching {
  opacity: 0.55;
  transition: opacity 0.12s ease;
}

@keyframes lt-coach-tables-station-in {
  from {
    opacity: 0.35;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.lt-coach-tables-dialog__body-main {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.lt-coach-tables-dialog__timer {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  margin-top: 0;
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid
    color-mix(in srgb, var(--lt-brand, #0877bc) 35%, rgba(255, 255, 255, 0.14));
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);
  color: #f8fafc;
  min-width: 88px;
}

.lt-coach-tables-dialog__chrome {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
  padding: 6px 12px;
  position: relative;
  z-index: 6;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(15, 23, 42, 0.35);
}

.lt-coach-tables-dialog__header-actions {
  position: relative;
  z-index: 8;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin: 0;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
}

.lt-coach-tables-dialog__header-actions--seat-features {
  justify-content: flex-start;
}

.lt-coach-tables-dialog__tool-group--seating-open {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, rgba(15, 23, 42, 0.72));
  border-color: color-mix(
    in srgb,
    var(--lt-brand, #0877bc) 55%,
    rgba(255, 255, 255, 0.2)
  );
}

.lt-coach-tables-dialog__tool-group {
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  gap: 2px;
  padding: 3px 4px 4px;
  border-radius: 11px;
  background: color-mix(
    in srgb,
    var(--lt-brand-secondary, #46528b) 16%,
    rgba(15, 23, 42, 0.65)
  );
  border: 1px solid
    color-mix(in srgb, var(--lt-brand, #0877bc) 26%, rgba(255, 255, 255, 0.1));
  flex-shrink: 0;
}

.lt-coach-tables-dialog__tool-group-label {
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  line-height: 1.2;
  padding: 1px 4px 0;
  color: color-mix(in srgb, var(--lt-brand, #0877bc) 42%, #f8fafc);
}

.lt-coach-tables-dialog__tool-group-row {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.lt-coach-tables-dialog__tool-group--capture {
  margin-left: auto;
  border-color: color-mix(
    in srgb,
    var(--lt-brand, #0877bc) 32%,
    rgba(255, 255, 255, 0.14)
  );
}

.lt-coach-tables-dialog__tool-group--capture.is-armed {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, rgba(15, 23, 42, 0.7));
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, rgba(255, 255, 255, 0.2));
}

.lt-coach-tables-dialog__tool-group--capture.is-live {
  background: rgba(127, 29, 29, 0.28);
  border-color: rgba(248, 113, 113, 0.5);
}

.lt-coach-tables-dialog__tool-group--capture.is-live .lt-coach-tables-dialog__tool-group-label {
  color: #fecaca;
}

.lt-coach-tables-dialog__timer-label {
  font-size: 0.65rem;
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.72);
  line-height: 1.2;
}

.lt-coach-tables-dialog__timer-value {
  font-size: 1.35rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  line-height: 1.1;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

.lt-coach-tables-dialog__timer--urgent {
  border-color: rgba(248, 113, 113, 0.55);
  background: rgba(220, 38, 38, 0.22);
}

.lt-coach-tables-dialog__timer--urgent .lt-coach-tables-dialog__timer-value {
  color: #fecaca;
}

.lt-coach-tables-dialog__timer--paused {
  border-color: rgba(251, 191, 36, 0.45);
  background: rgba(245, 158, 11, 0.16);
}

.lt-coach-tables-dialog__timer--paused .lt-coach-tables-dialog__timer-value {
  color: #fde68a;
}

.lt-coach-tables-dialog__stat {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 999px;
  background: color-mix(
    in srgb,
    var(--lt-brand, #0877bc) 12%,
    rgba(15, 23, 42, 0.45)
  );
  border: 1px solid
    color-mix(in srgb, var(--lt-brand, #0877bc) 24%, rgba(255, 255, 255, 0.1));
  font-size: 0.73rem;
  font-weight: 700;
  color: rgba(248, 250, 252, 0.9);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.lt-coach-tables-dialog__stat svg {
  color: color-mix(in srgb, var(--lt-brand, #0877bc) 75%, #f8fafc);
  font-size: 0.92rem !important;
}

.lt-coach-tables-dialog__stat--timer {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.lt-coach-tables-dialog__stat--timer.is-urgent {
  color: #fecaca;
  background: rgba(220, 38, 38, 0.22);
  border-color: rgba(248, 113, 113, 0.5);
}

.lt-coach-tables-dialog__stat--timer.is-urgent svg {
  color: #f87171;
}

.lt-coach-tables-dialog__stat--timer.is-paused {
  color: #fde68a;
  background: rgba(245, 158, 11, 0.16);
  border-color: rgba(251, 191, 36, 0.45);
}

.lt-coach-tables-dialog__stat--timer.is-paused svg {
  color: #fbbf24;
}

.lt-coach-tables-dialog__stat--warn {
  color: #fde68a;
  background: rgba(245, 158, 11, 0.16);
  border-color: rgba(251, 191, 36, 0.45);
}

.lt-coach-tables-dialog__stat-extra {
  margin-left: 2px;
  font-weight: 600;
  opacity: 0.72;
  font-size: 0.68rem;
}

.lt-coach-tables-dialog__stat--warn svg {
  color: #fbbf24;
}

.lt-coach-tables-dialog__stations {
  margin-top: 4px;
  min-width: 0;
}

.lt-coach-tables-dialog__stations .lt-station-tabs {
  padding: 0 2px 2px;
  gap: 6px;
}

.lt-coach-tables-dialog__stations .lt-station-tabs__btn {
  padding: 5px 10px;
  font-size: 0.72rem;
}

.lt-coach-tables-dialog__unseated {
  flex-shrink: 0;
  margin: 0 10px 6px;
  padding: 8px 10px;
  border-radius: 10px;
  background: color-mix(
    in srgb,
    var(--lt-brand-secondary, #46528b) 18%,
    transparent
  );
  border: 1px solid
    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 40%, transparent);
}

.lt-coach-tables-dialog__unseated--other-station {
  background: color-mix(in srgb, #f59e0b 12%, transparent);
  border-color: color-mix(in srgb, #f59e0b 40%, transparent);
}

.lt-coach-tables-dialog__station-move {
  flex-shrink: 0;
  margin: 0 10px 6px;
  padding: 8px 10px;
  border-radius: 10px;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, transparent);
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);
}

.lt-coach-tables-dialog__station-move-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.lt-coach-tables-dialog__station-move-head h3 {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  color: rgba(248, 250, 252, 0.92);
}

.lt-coach-tables-dialog__station-swap-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, #fbbf24 55%, transparent);
  background: color-mix(in srgb, #f59e0b 22%, transparent);
  color: #fde68a;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
}

.lt-coach-tables-dialog__station-swap-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lt-coach-tables-dialog__station-move-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.lt-coach-tables-dialog__station-move-btn {
  padding: 5px 10px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(15, 23, 42, 0.35);
  color: rgba(248, 250, 252, 0.9);
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
}

.lt-coach-tables-dialog__station-move-btn--selected {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, transparent);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 32%, transparent);
  color: #fff;
}

.lt-coach-tables-dialog__station-move-btn--quick {
  border-color: color-mix(in srgb, #22c55e 55%, transparent);
  background: color-mix(in srgb, #22c55e 22%, transparent);
  color: #bbf7d0;
}

.lt-coach-tables-dialog__station-move-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lt-coach-tables-dialog__dest-banner {
  margin: 0 0 8px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #f8fafc;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);
}

.light-mode .lt-coach-tables-dialog__dest-banner {
  color: #0f172a;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);
}

.lt-coach-tables-dialog__dest-tables {
  margin-top: 8px;
}

.lt-coach-tables-dialog__dest-tables-hint {
  margin: 0 0 6px;
  font-size: 0.72rem;
  color: rgba(248, 250, 252, 0.65);
}

.lt-coach-tables-dialog__dest-tables-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 6px;
  max-height: 180px;
  overflow-y: auto;
}

.light-mode .lt-coach-tables-dialog__station-move {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 8%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);
}

.light-mode .lt-coach-tables-dialog__station-move-head h3,
.light-mode .lt-coach-tables-dialog__dest-tables-hint {
  color: #0f172a;
}

.light-mode .lt-coach-tables-dialog__station-move-btn {
  background: #fff;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-coach-tables-dialog__station-swap-btn {
  color: #92400e;
}

.lt-coach-tables-dialog__unseated-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.lt-coach-tables-dialog__unseated-head h3 {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  color: color-mix(in srgb, #fde68a 70%, #f8fafc);
}

.lt-coach-tables-dialog__unseated-count {
  min-width: 1.4rem;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  background: color-mix(in srgb, #fbbf24 28%, transparent);
  color: #fde68a;
  text-align: center;
}

.lt-coach-tables-dialog__unseated-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 88px;
  overflow-y: auto;
}

.lt-coach-tables-dialog__unseated-list > li {
  margin: 0;
  padding: 0;
  border: 0;
}

.lt-coach-tables-dialog__unseated-btn,
.lt-coach-tables-dialog__unseated-row {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(15, 23, 42, 0.35);
  color: rgba(248, 250, 252, 0.9);
  font-size: 0.78rem;
  line-height: 1.2;
}

.lt-coach-tables-dialog__unseated-btn {
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    transform 0.12s ease;
}

.lt-coach-tables-dialog__unseated-btn:hover {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);
}

.lt-coach-tables-dialog__unseated-btn:active {
  transform: scale(0.98);
}

.lt-coach-tables-dialog__unseated-btn--selected {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 36%, transparent);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, transparent);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);
}

.lt-coach-tables-dialog__unseated-btn span:last-child,
.lt-coach-tables-dialog__unseated-row span:last-child {
  opacity: 0.72;
  font-size: 0.7rem;
  font-variant-numeric: tabular-nums;
}

.lt-coach-tables-dialog__close {
  flex-shrink: 0;
  margin-left: auto;
}

.lt-coach-tables-dialog__seating-toolbar {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 4px;
  flex-shrink: 0;
  padding: 0;
  margin: 0;
}

.lt-coach-tables-dialog__tool-expand {
  position: relative;
  display: inline-flex;
  align-items: flex-start;
  flex-shrink: 0;
}

.lt-coach-tables-dialog__tool-overlay {
  position: absolute;
  top: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 132px;
  padding: 4px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(15, 23, 42, 0.96);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);
}

.lt-coach-tables-dialog__tool-overlay-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #f8fafc;
  font-size: 0.78rem;
  font-weight: 650;
  cursor: pointer;
  text-align: left;
}

.lt-coach-tables-dialog__tool-overlay-item:hover:not(:disabled) {
  background: rgba(8, 119, 188, 0.28);
}

.lt-coach-tables-dialog__tool-overlay-item:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Bottom caption / voice dock — keeps action buttons free and 5-table grid stable. */
.lt-coach-tables-dialog__footer.lt-coach-tables-dialog__caption-dock {
  padding: 4px 10px calc(6px + env(safe-area-inset-bottom, 0px));
  flex-shrink: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.55);
  z-index: 10;
}

.lt-coach-tables-dialog__caption-slot {
  position: relative;
  flex-shrink: 0;
  min-height: 32px;
  width: 100%;
}

.lt-coach-tables-dialog.lt-pingflo-caption-open .lt-coach-tables-dialog__caption-slot {
  min-height: 52px;
}

.lt-coach-tables-dialog__seating-msg {
  margin: 0;
  padding: 6px 10px;
  min-height: 32px;
  border-radius: 8px;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 16%, transparent);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #e2e8f0;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.3;
  box-sizing: border-box;
}

.lt-coach-tables-dialog__seating-msg.is-empty {
  background: transparent;
  border-color: transparent;
  color: transparent;
}

.lt-coach-tables-dialog__caption-slot:has(.lt-pingflo-voice__portal) .lt-coach-tables-dialog__seating-msg {
  display: none;
}

/* Light mode — table configuration */
.light-mode .lt-coach-tables-dialog.lt-table-wizard {
  background: linear-gradient(
    165deg,
    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 10%, #f8fafc) 0%,
    #ffffff 55%,
    #f1f5f9 100%
  );
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-coach-tables-dialog__title-row h2,
.light-mode .lt-coach-tables-dialog__stat,
.light-mode .lt-coach-tables-dialog__timer-value,
.light-mode .lt-coach-tables-dialog__page-meta {
  color: #0f172a;
}

.light-mode .lt-coach-tables-dialog__timer-label,
.light-mode .lt-coach-tables-dialog__stat {
  color: #334155;
}

.light-mode .lt-coach-tables-dialog__timer {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-coach-tables-dialog__chrome {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 4%, #f8fafc);
  border-bottom-color: rgba(15, 23, 42, 0.08);
}

.light-mode .lt-coach-tables-dialog__tool-group {
  background: #ffffff;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 24%, #cbd5e1);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.light-mode .lt-coach-tables-dialog__tool-group-label {
  color: var(--lt-brand, #0877bc);
}

.light-mode .lt-coach-tables-dialog__tool-group--capture.is-armed {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, #cbd5e1);
}

.light-mode .lt-coach-tables-dialog__tool-group--capture.is-live {
  background: #fef2f2;
  border-color: #fca5a5;
}

.light-mode .lt-coach-tables-dialog__tool-group--capture.is-live .lt-coach-tables-dialog__tool-group-label {
  color: #b91c1c;
}

.light-mode .lt-coach-tables-dialog__stat {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 8%, #ffffff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 24%, #cbd5e1);
  color: #1e293b;
}

.light-mode .lt-coach-tables-dialog__stat svg {
  color: var(--lt-brand, #0877bc);
}

.light-mode .lt-coach-tables-dialog__tool-btn {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 8%, #f8fafc);
  border-color: transparent;
  color: #0f172a;
}

.light-mode .lt-coach-tables-dialog__tool-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 16%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 38%, #94a3b8);
}

.light-mode .lt-coach-tables-dialog__tool-btn--active {
  background: var(--lt-brand, #0877bc);
  border-color: var(--lt-brand, #0877bc);
  color: #ffffff;
}

.light-mode .lt-coach-tables-dialog__tool-btn--recording {
  background: #dc2626;
  border-color: #ef4444;
  color: #ffffff;
}

.light-mode .lt-coach-tables-dialog__pingflo-mic {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #f8fafc);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 30%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-coach-tables-dialog__stat--warn {
  color: #b45309;
}

.light-mode .lt-coach-tables-dialog__stat--warn svg {
  color: #d97706;
}

.light-mode .lt-coach-tables-dialog__unseated {
  background: color-mix(in srgb, #f59e0b 10%, #fff);
  border-color: color-mix(in srgb, #f59e0b 35%, #cbd5e1);
}

.light-mode .lt-coach-tables-dialog__unseated-head h3 {
  color: #92400e;
}

.light-mode .lt-coach-tables-dialog__unseated-count {
  background: color-mix(in srgb, #f59e0b 22%, #fff);
  color: #92400e;
}

.light-mode .lt-coach-tables-dialog__unseated-btn,
.light-mode .lt-coach-tables-dialog__unseated-row {
  background: #fff;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-coach-tables-dialog__unseated-btn:hover {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);
}

.light-mode .lt-coach-tables-dialog__footer.lt-coach-tables-dialog__caption-dock {
  background: rgba(248, 250, 252, 0.92);
  border-top-color: rgba(15, 23, 42, 0.1);
}

.light-mode .lt-coach-tables-dialog__seating-msg {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-coach-tables-dialog__edge {
  background: linear-gradient(
    90deg,
    rgba(248, 250, 252, 0.95),
    rgba(248, 250, 252, 0)
  );
  color: #0f172a;
}

.light-mode .lt-coach-tables-dialog__edge--next {
  background: linear-gradient(
    270deg,
    rgba(248, 250, 252, 0.95),
    rgba(248, 250, 252, 0)
  );
}

.lt-coach-tables-dialog__tool-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-width: 34px;
  height: 34px;
  padding: 0 7px;
  border-radius: 9px;
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.05);
  color: #f8fafc;
  font: inherit;
  font-size: 0.74rem;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.1s ease;
  flex-shrink: 0;
}

.lt-coach-tables-dialog__tool-btn--pill {
  padding: 0 10px;
}

.lt-coach-tables-dialog__tool-btn-text {
  white-space: nowrap;
  line-height: 1;
}

.lt-coach-tables-dialog__tool-btn-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: #f59e0b;
  color: #0f172a;
  font-size: 0.64rem;
  font-weight: 800;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.lt-coach-tables-dialog__tool-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);
}

.lt-coach-tables-dialog__tool-btn--emphasis {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, rgba(255, 255, 255, 0.2));
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);
}

.lt-coach-tables-dialog__tool-btn--emphasis:hover:not(:disabled) {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 34%, transparent);
}

/* Active configuration/seating tool (Sort, Rotate, Move): brand highlight */
.lt-coach-tables-dialog__tool-btn--active {
  background: var(--lt-brand, #0877bc);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #ffffff);
  color: #ffffff;
  box-shadow: 0 2px 10px color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);
}

/* Active live recording mode (Video / Voice): high-contrast crimson pulse */
.lt-coach-tables-dialog__tool-btn--recording {
  background: #dc2626;
  border-color: #f87171;
  color: #ffffff;
  animation: lt-coach-recording-pulse 1.5s infinite;
}

.lt-coach-tables-dialog__tool-btn:disabled {
  opacity: 0.42;
  cursor: not-allowed;
}

.lt-coach-tables-dialog__capture-batch-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 34px;
  padding: 0 10px;
  border-radius: 9px;
  border: 1px solid rgba(248, 113, 113, 0.55);
  background: rgba(220, 38, 38, 0.22);
  color: #fecaca;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.lt-coach-tables-dialog__capture-batch-btn:hover:not(:disabled) {
  background: rgba(220, 38, 38, 0.35);
  color: #ffffff;
}

.lt-coach-tables-dialog__capture-batch-btn--stop {
  background: #dc2626;
  border-color: #fca5a5;
  color: #ffffff;
}

.lt-coach-tables-dialog__capture-batch-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.lt-coach-tables-dialog__pingflo-micro {
  position: relative;
  flex: 0 0 auto;
  margin: 0;
  min-width: 0;
}

.lt-coach-tables-dialog__pingflo-mic {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 9px;
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, rgba(255, 255, 255, 0.18));
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);
  overflow: hidden;
  cursor: pointer;
  color: inherit;
}

.lt-coach-tables-dialog__pingflo-mic:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.lt-coach-tables-dialog__pingflo-mark {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
}

.lt-table-wizard__voice--micro .lt-table-wizard__voice-box--popover {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  width: min(320px, calc(100vw - 32px));
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}

.lt-table-wizard__voice--micro .lt-table-wizard__banner {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 19;
  width: min(280px, calc(100vw - 32px));
  border-radius: 10px;
  padding: 8px 10px;
  margin: 0;
  font-size: 0.72rem;
}

.lt-table-wizard__voice-portal {
  position: fixed;
  inset: 0;
  z-index: 1600;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 16px;
  padding-bottom: max(16px, env(safe-area-inset-bottom));
  background: rgba(8, 15, 28, 0.55);
  box-sizing: border-box;
}

.lt-table-wizard__voice-box--portal {
  width: min(420px, 100%);
  margin: 0;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.5);
}

.lt-table-wizard__voice-examples {
  margin: 0 0 8px;
  font-size: 0.72rem;
  line-height: 1.35;
  color: rgba(248, 250, 252, 0.7);
}

.lt-coach-tables-dialog__seating-msg.lt-coach-tables-dialog__recording-hint {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #fcd34d;
  font-weight: 700;
  background: rgba(251, 191, 36, 0.12);
  border-color: rgba(251, 191, 36, 0.35);
}

.lt-coach-tables-dialog__seating-msg.lt-coach-tables-dialog__recording-hint--live {
  color: #fca5a5;
  background: rgba(239, 68, 68, 0.14);
  border-color: rgba(239, 68, 68, 0.45);
}

.light-mode .lt-coach-tables-dialog__seating-msg.lt-coach-tables-dialog__recording-hint {
  color: #92400e;
  background: #fef3c7;
  border-color: #fcd34d;
}

.light-mode .lt-coach-tables-dialog__seating-msg.lt-coach-tables-dialog__recording-hint--live {
  color: #b91c1c;
  background: #fee2e2;
  border-color: #fca5a5;
}

@keyframes lt-coach-recording-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.45);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(211, 47, 47, 0);
  }
}

.lt-coach-tables-dialog__progress {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  flex-shrink: 0;
}

.lt-coach-tables-dialog__progress-label {
  font-size: 0.8rem;
  font-weight: 700;
  color: #f8fafc;
}

.lt-coach-tables-dialog__progress-done {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.74rem;
  font-weight: 700;
  color: #86efac;
}

.lt-coach-tables-dialog__status-pill {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: rgba(56, 189, 248, 0.16);
  border: 1px solid rgba(56, 189, 248, 0.35);
  color: #7dd3fc;
}

.lt-coach-dash__kot-done {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.65rem;
  font-weight: 700;
  color: #86efac;
}

/* Swipe pages of tables sized to the available viewport */
.lt-coach-tables-dialog__body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.lt-coach-tables-dialog__pager {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: stretch;
}

.lt-coach-tables-dialog__pages {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.lt-coach-tables-dialog__pages::-webkit-scrollbar {
  display: none;
}

.lt-coach-tables-dialog__page {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  padding: 0 28px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.lt-coach-tables-dialog__grid {
  display: grid;
  grid-template-columns: repeat(var(--lt-tables-cols, 1), minmax(0, 1fr));
  /* Size each row to its card content so 2-player tables stay compact */
  grid-template-rows: repeat(var(--lt-tables-rows, 5), auto);
  gap: 5px;
  width: 100%;
  min-height: 0;
  height: auto;
  align-content: start;
  box-sizing: border-box;
}

.lt-coach-tables-dialog__grid > .lt-coach-table,
.lt-coach-tables-dialog__grid > .lt-table-wizard__card {
  height: auto;
  min-height: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 5px 7px;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 32%, rgba(255, 255, 255, 0.12));
}

.lt-coach-tables-dialog__grid > .lt-coach-table--multi,
.lt-coach-tables-dialog__grid > .lt-coach-table--has-classement.lt-coach-table--multi {
  height: auto;
  min-height: 0;
  justify-content: flex-start;
  padding: 6px 8px;
  overflow: visible;
}

/* Dual A-vs-B cards: keep the tight pre-multi footprint */
.lt-coach-tables-dialog__grid > .lt-coach-table:not(.lt-coach-table--multi) {
  padding: 5px 7px;
}

.lt-coach-tables-dialog__grid > .lt-coach-table--slot-empty {
  min-height: 0;
  height: 100%;
  visibility: hidden;
  pointer-events: none;
}

.lt-coach-tables-dialog__edge {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 3;
  width: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: linear-gradient(
    90deg,
    rgba(15, 23, 42, 0.88),
    rgba(15, 23, 42, 0)
  );
  color: #f8fafc;
  cursor: pointer;
}

.lt-coach-tables-dialog__edge--prev {
  left: 0;
}

.lt-coach-tables-dialog__edge--next {
  right: 0;
  background: linear-gradient(
    270deg,
    rgba(15, 23, 42, 0.88),
    rgba(15, 23, 42, 0)
  );
}

.lt-coach-tables-dialog__edge:disabled {
  opacity: 0.22;
  cursor: default;
}

.lt-coach-tables-dialog__edge:not(:disabled):active {
  color: var(--lt-brand, #0877bc);
}

.lt-coach-tables-dialog__page-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 0.72rem;
  font-weight: 700;
  color: rgba(248, 250, 252, 0.7);
  flex-shrink: 0;
}

.lt-coach-tables-dialog__dots {
  display: inline-flex;
  gap: 6px;
}

.lt-coach-tables-dialog__dot {
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(248, 250, 252, 0.28);
  cursor: pointer;
}

.lt-coach-tables-dialog__dot--on {
  transform: scale(1.2);
}

.lt-coach-tables-dialog__footer {
  padding: 8px 12px 10px;
  flex-shrink: 0;
}

/* Leave room handled by footer dock itself — do not pad extra under actions. */
.lt-coach-tables-dialog.lt-pingflo-caption-open .lt-coach-tables-dialog__footer {
  padding-bottom: calc(6px + env(safe-area-inset-bottom, 0px));
}

@media (max-width: 520px) {
  .lt-coach-tables-dialog.lt-table-wizard {
    width: 100%;
    border-radius: 12px;
  }

  .lt-coach-tables-dialog__header {
    flex-wrap: wrap;
  }

  .lt-coach-tables-dialog__header-actions {
    width: 100%;
    justify-content: space-between;
  }

  .lt-coach-tables-dialog__page {
    padding: 0 24px;
  }

  .lt-coach-tables-dialog__grid > .lt-coach-table,
  .lt-coach-tables-dialog__grid > .lt-table-wizard__card {
    min-height: 64px;
  }
}

/* Landscape: use horizontal space — 2-column grid, compact chrome */
@media (orientation: landscape) {
  .lt-coach-tables-dialog__backdrop {
    padding: 6px;
    padding-bottom: var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));
  }

  .lt-coach-tables-dialog.lt-table-wizard {
    width: min(920px, 100%);
    height: calc(
      var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 12px -
        env(safe-area-inset-top, 0px)
    );
    max-height: calc(
      var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 12px -
        env(safe-area-inset-top, 0px)
    );
  }

  .lt-coach-tables-dialog__header {
    padding: 6px 10px;
    align-items: center;
    gap: 6px;
  }

  .lt-coach-tables-dialog__header-main {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 14px;
  }

  .lt-coach-tables-dialog__title-row h2 {
    font-size: 0.92rem;
  }

  .lt-coach-tables-dialog__stats {
    margin-top: 0;
    gap: 8px;
  }

  .lt-coach-tables-dialog__timer {
    margin-top: 0;
    padding: 4px 8px;
    min-width: 72px;
    flex-direction: row;
    align-items: baseline;
    gap: 8px;
  }

  .lt-coach-tables-dialog__timer-label {
    font-size: 0.6rem;
  }

  .lt-coach-tables-dialog__timer-value {
    font-size: 1.1rem;
  }

  .lt-coach-tables-dialog__tool-btn,
  .lt-coach-tables-dialog__pingflo-mic {
    min-width: 34px;
    height: 34px;
  }

  .lt-coach-tables-dialog__tool-btn--pill {
    width: auto;
  }

  .lt-coach-tables-dialog .lt-table-wizard__body {
    padding: 4px 10px;
  }

  .lt-coach-tables-dialog__grid {
    gap: 6px;
  }

  .lt-coach-tables-dialog__page {
    padding: 0 22px;
  }

  .lt-coach-tables-dialog__page-meta {
    margin-top: 4px;
    padding-top: 4px;
  }

  .lt-coach-tables-dialog__footer {
    padding: 6px 10px 8px;
  }

  .lt-coach-tables-dialog__progress {
    padding: 4px 10px;
  }
}

@media (orientation: landscape) and (max-height: 520px) {
  .lt-coach-tables-dialog.lt-table-wizard {
    height: calc(
      var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 8px -
        env(safe-area-inset-top, 0px)
    );
    max-height: calc(
      var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 8px -
        env(safe-area-inset-top, 0px)
    );
  }

  .lt-coach-tables-dialog__header {
    padding: 4px 8px;
  }

  .lt-coach-tables-dialog__title-row h2 {
    font-size: 0.85rem;
  }

  .lt-coach-tables-dialog__stat {
    font-size: 0.68rem;
  }

  .lt-coach-tables-dialog__grid {
    gap: 4px;
  }

  .lt-coach-tables-dialog__recording-hint {
    padding: 3px 8px;
    font-size: 0.7rem;
  }

  .lt-coach-tables-dialog__grid > .lt-coach-table,
  .lt-coach-tables-dialog__grid > .lt-table-wizard__card {
    min-height: 56px;
    padding: 6px 8px;
  }

  .lt-coach-tables-dialog__footer {
    padding: 6px 10px 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingCoachTablesDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,qFAAqF;EACrF,sBAAsB;AACxB;;AAEA,0FAA0F;AAC1F;EACE,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mEAAmE;EACnE;;;GAGC;EACD;;;GAGC;EACD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB;+EAC6E;EAC7E;;;;GAIC;AACH;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,MAAM;EACN,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,aAAa;IACb,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB;+EAC6E;EAC7E,yEAAyE;EACzE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,kDAAkD;EAClD,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oFAAoF;EACpF;;;;GAIC;AACH;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB;;;;GAIC;EACD;8EAC4E;EAC5E,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB;;;;GAIC;AACH;;AAEA;EACE,mFAAmF;EACnF,wFAAwF;AAC1F;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB;;;;GAIC;EACD;8EAC4E;EAC5E,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gEAAgE;EAChE,6BAA6B;AAC/B;;AAEA;EACE,2DAA2D;EAC3D,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB;;;;GAIC;EACD;2EACyE;AAC3E;;AAEA;EACE,wDAAwD;EACxD,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yEAAyE;EACzE,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,8DAA8D;EAC9D,wDAAwD;EACxD,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2EAA2E;EAC3E,yEAAyE;EACzE,WAAW;AACb;;AAEA;EACE,0DAA0D;EAC1D,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yEAAyE;EACzE,+EAA+E;AACjF;;AAEA;EACE,cAAc;EACd,kEAAkE;AACpE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iEAAiE;EACjE,uEAAuE;AACzE;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,wDAAwD;EACxD,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf;;;wBAGsB;AACxB;;AAEA;EACE,yEAAyE;EACzE,2EAA2E;AAC7E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yEAAyE;EACzE,2EAA2E;EAC3E,mFAAmF;AACrF;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,qFAAqF;AACrF;EACE,8DAA8D;EAC9D,cAAc;EACd,+CAA+C;EAC/C,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yEAAyE;EACzE,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE;;;;;GAKC;EACD,uEAAuE;EACvE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kEAAkE;EAClE,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,oEAAoE;EACpE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,uEAAuE;EACvE,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kEAAkE;EAClE,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oEAAoE;EACpE,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oEAAoE;EACpE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kEAAkE;EAClE,uEAAuE;AACzE;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qEAAqE;EACrE,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,kEAAkE;EAClE,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE;;;;GAIC;EACD,cAAc;AAChB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;;;;uBAKqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,yEAAyE;EACzE,2EAA2E;AAC7E;;AAEA;EACE,wFAAwF;EACxF,yEAAyE;AAC3E;;AAEA;EACE,yEAAyE;AAC3E;;AAEA,4EAA4E;AAC5E;EACE,oCAAoC;EACpC,uEAAuE;EACvE,cAAc;EACd,oFAAoF;AACtF;;AAEA,4EAA4E;AAC5E;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,6FAA6F;EAC7F,yEAAyE;EACzE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,sDAAsD;EACtD,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;;IAEE,2CAA2C;EAC7C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kDAAkD;EAClD,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,sEAAsE;EACtE,0DAA0D;EAC1D,QAAQ;EACR,WAAW;EACX,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,yFAAyF;AAC3F;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ;;;;GAIC;EACD,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;EACR;;;;GAIC;AACH;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,4DAA4D;AAC9D;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,YAAY;IACZ,qFAAqF;EACvF;;EAEA;IACE,uBAAuB;IACvB;;;KAGC;IACD;;;KAGC;EACH;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE;;;KAGC;IACD;;;KAGC;EACH;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".lt-coach-tables-dialog__backdrop {\n  z-index: 1350;\n  align-items: stretch;\n  justify-content: center;\n  padding: 8px;\n  padding-bottom: var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));\n  box-sizing: border-box;\n}\n\n/* Above session results (9999), nested exercise sheet (10050), change-exercise (16000). */\n.lt-coach-tables-dialog__backdrop--elevated {\n  z-index: 16100;\n  padding-bottom: max(8px, env(safe-area-inset-bottom, 0px));\n}\n\n.lt-coach-tables-dialog.lt-table-wizard {\n  position: relative;\n  width: min(560px, 100%);\n  max-width: 100%;\n  max-height: none;\n  /* Prefer visual-viewport height used by immersive live training. */\n  height: calc(\n    var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 16px -\n      env(safe-area-inset-top, 0px)\n  );\n  max-height: calc(\n    var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 16px -\n      env(safe-area-inset-top, 0px)\n  );\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.lt-coach-tables-dialog--multi-col.lt-table-wizard {\n  width: min(920px, 100%);\n}\n\n.lt-coach-tables-dialog .lt-table-wizard__body {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1 1 auto;\n  padding: 8px 12px 6px;\n}\n\n.lt-coach-tables-dialog__header {\n  align-items: flex-start;\n  padding: 10px 12px 6px;\n  flex-shrink: 0;\n  gap: 6px;\n  flex-wrap: nowrap;\n  position: relative;\n  border-bottom: 1px solid\n    color-mix(in srgb, var(--lt-brand, #0877bc) 18%, rgba(255, 255, 255, 0.08));\n  background: linear-gradient(\n    180deg,\n    color-mix(in srgb, var(--lt-brand, #0877bc) 10%, rgba(15, 23, 42, 0.6)) 0%,\n    transparent 100%\n  );\n}\n\n.lt-coach-tables-dialog__header-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lt-coach-tables-dialog__title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex-wrap: nowrap;\n}\n\n.lt-coach-tables-dialog__title-row h2 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 750;\n  letter-spacing: -0.01em;\n  line-height: 1.25;\n  color: #f8fafc;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.lt-coach-tables-dialog__club-logo {\n  flex-shrink: 0;\n}\n\n.lt-coach-tables-dialog__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 2px;\n  padding-left: 0;\n}\n\n.lt-coach-tables-dialog__stats--below {\n  margin-top: 0;\n  margin-left: 0;\n  padding-left: 0;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.lt-coach-tables-dialog__body {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n  min-height: 0;\n  animation: lt-coach-tables-station-in 0.22s ease;\n}\n\n.lt-coach-tables-dialog__body--switching {\n  opacity: 0.55;\n  transition: opacity 0.12s ease;\n}\n\n@keyframes lt-coach-tables-station-in {\n  from {\n    opacity: 0.35;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.lt-coach-tables-dialog__body-main {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.lt-coach-tables-dialog__timer {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1px;\n  margin-top: 0;\n  padding: 6px 10px;\n  border-radius: 10px;\n  border: 1px solid\n    color-mix(in srgb, var(--lt-brand, #0877bc) 35%, rgba(255, 255, 255, 0.14));\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);\n  color: #f8fafc;\n  min-width: 88px;\n}\n\n.lt-coach-tables-dialog__chrome {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex-shrink: 0;\n  padding: 6px 12px;\n  position: relative;\n  z-index: 6;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(15, 23, 42, 0.35);\n}\n\n.lt-coach-tables-dialog__header-actions {\n  position: relative;\n  z-index: 8;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  margin: 0;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: visible;\n  -webkit-overflow-scrolling: touch;\n}\n\n.lt-coach-tables-dialog__header-actions--seat-features {\n  justify-content: flex-start;\n}\n\n.lt-coach-tables-dialog__tool-group--seating-open {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, rgba(15, 23, 42, 0.72));\n  border-color: color-mix(\n    in srgb,\n    var(--lt-brand, #0877bc) 55%,\n    rgba(255, 255, 255, 0.2)\n  );\n}\n\n.lt-coach-tables-dialog__tool-group {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 2px;\n  padding: 3px 4px 4px;\n  border-radius: 11px;\n  background: color-mix(\n    in srgb,\n    var(--lt-brand-secondary, #46528b) 16%,\n    rgba(15, 23, 42, 0.65)\n  );\n  border: 1px solid\n    color-mix(in srgb, var(--lt-brand, #0877bc) 26%, rgba(255, 255, 255, 0.1));\n  flex-shrink: 0;\n}\n\n.lt-coach-tables-dialog__tool-group-label {\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  padding: 1px 4px 0;\n  color: color-mix(in srgb, var(--lt-brand, #0877bc) 42%, #f8fafc);\n}\n\n.lt-coach-tables-dialog__tool-group-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.lt-coach-tables-dialog__tool-group--capture {\n  margin-left: auto;\n  border-color: color-mix(\n    in srgb,\n    var(--lt-brand, #0877bc) 32%,\n    rgba(255, 255, 255, 0.14)\n  );\n}\n\n.lt-coach-tables-dialog__tool-group--capture.is-armed {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, rgba(15, 23, 42, 0.7));\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, rgba(255, 255, 255, 0.2));\n}\n\n.lt-coach-tables-dialog__tool-group--capture.is-live {\n  background: rgba(127, 29, 29, 0.28);\n  border-color: rgba(248, 113, 113, 0.5);\n}\n\n.lt-coach-tables-dialog__tool-group--capture.is-live .lt-coach-tables-dialog__tool-group-label {\n  color: #fecaca;\n}\n\n.lt-coach-tables-dialog__timer-label {\n  font-size: 0.65rem;\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.72);\n  line-height: 1.2;\n}\n\n.lt-coach-tables-dialog__timer-value {\n  font-size: 1.35rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n\n.lt-coach-tables-dialog__timer--urgent {\n  border-color: rgba(248, 113, 113, 0.55);\n  background: rgba(220, 38, 38, 0.22);\n}\n\n.lt-coach-tables-dialog__timer--urgent .lt-coach-tables-dialog__timer-value {\n  color: #fecaca;\n}\n\n.lt-coach-tables-dialog__timer--paused {\n  border-color: rgba(251, 191, 36, 0.45);\n  background: rgba(245, 158, 11, 0.16);\n}\n\n.lt-coach-tables-dialog__timer--paused .lt-coach-tables-dialog__timer-value {\n  color: #fde68a;\n}\n\n.lt-coach-tables-dialog__stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: color-mix(\n    in srgb,\n    var(--lt-brand, #0877bc) 12%,\n    rgba(15, 23, 42, 0.45)\n  );\n  border: 1px solid\n    color-mix(in srgb, var(--lt-brand, #0877bc) 24%, rgba(255, 255, 255, 0.1));\n  font-size: 0.73rem;\n  font-weight: 700;\n  color: rgba(248, 250, 252, 0.9);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.lt-coach-tables-dialog__stat svg {\n  color: color-mix(in srgb, var(--lt-brand, #0877bc) 75%, #f8fafc);\n  font-size: 0.92rem !important;\n}\n\n.lt-coach-tables-dialog__stat--timer {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.lt-coach-tables-dialog__stat--timer.is-urgent {\n  color: #fecaca;\n  background: rgba(220, 38, 38, 0.22);\n  border-color: rgba(248, 113, 113, 0.5);\n}\n\n.lt-coach-tables-dialog__stat--timer.is-urgent svg {\n  color: #f87171;\n}\n\n.lt-coach-tables-dialog__stat--timer.is-paused {\n  color: #fde68a;\n  background: rgba(245, 158, 11, 0.16);\n  border-color: rgba(251, 191, 36, 0.45);\n}\n\n.lt-coach-tables-dialog__stat--timer.is-paused svg {\n  color: #fbbf24;\n}\n\n.lt-coach-tables-dialog__stat--warn {\n  color: #fde68a;\n  background: rgba(245, 158, 11, 0.16);\n  border-color: rgba(251, 191, 36, 0.45);\n}\n\n.lt-coach-tables-dialog__stat-extra {\n  margin-left: 2px;\n  font-weight: 600;\n  opacity: 0.72;\n  font-size: 0.68rem;\n}\n\n.lt-coach-tables-dialog__stat--warn svg {\n  color: #fbbf24;\n}\n\n.lt-coach-tables-dialog__stations {\n  margin-top: 4px;\n  min-width: 0;\n}\n\n.lt-coach-tables-dialog__stations .lt-station-tabs {\n  padding: 0 2px 2px;\n  gap: 6px;\n}\n\n.lt-coach-tables-dialog__stations .lt-station-tabs__btn {\n  padding: 5px 10px;\n  font-size: 0.72rem;\n}\n\n.lt-coach-tables-dialog__unseated {\n  flex-shrink: 0;\n  margin: 0 10px 6px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: color-mix(\n    in srgb,\n    var(--lt-brand-secondary, #46528b) 18%,\n    transparent\n  );\n  border: 1px solid\n    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 40%, transparent);\n}\n\n.lt-coach-tables-dialog__unseated--other-station {\n  background: color-mix(in srgb, #f59e0b 12%, transparent);\n  border-color: color-mix(in srgb, #f59e0b 40%, transparent);\n}\n\n.lt-coach-tables-dialog__station-move {\n  flex-shrink: 0;\n  margin: 0 10px 6px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 14%, transparent);\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);\n}\n\n.lt-coach-tables-dialog__station-move-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.lt-coach-tables-dialog__station-move-head h3 {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: rgba(248, 250, 252, 0.92);\n}\n\n.lt-coach-tables-dialog__station-swap-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, #fbbf24 55%, transparent);\n  background: color-mix(in srgb, #f59e0b 22%, transparent);\n  color: #fde68a;\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.lt-coach-tables-dialog__station-swap-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.lt-coach-tables-dialog__station-move-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.lt-coach-tables-dialog__station-move-btn {\n  padding: 5px 10px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(15, 23, 42, 0.35);\n  color: rgba(248, 250, 252, 0.9);\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.lt-coach-tables-dialog__station-move-btn--selected {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, transparent);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 32%, transparent);\n  color: #fff;\n}\n\n.lt-coach-tables-dialog__station-move-btn--quick {\n  border-color: color-mix(in srgb, #22c55e 55%, transparent);\n  background: color-mix(in srgb, #22c55e 22%, transparent);\n  color: #bbf7d0;\n}\n\n.lt-coach-tables-dialog__station-move-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.lt-coach-tables-dialog__dest-banner {\n  margin: 0 0 8px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #f8fafc;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);\n}\n\n.light-mode .lt-coach-tables-dialog__dest-banner {\n  color: #0f172a;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);\n}\n\n.lt-coach-tables-dialog__dest-tables {\n  margin-top: 8px;\n}\n\n.lt-coach-tables-dialog__dest-tables-hint {\n  margin: 0 0 6px;\n  font-size: 0.72rem;\n  color: rgba(248, 250, 252, 0.65);\n}\n\n.lt-coach-tables-dialog__dest-tables-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 6px;\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.light-mode .lt-coach-tables-dialog__station-move {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 8%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);\n}\n\n.light-mode .lt-coach-tables-dialog__station-move-head h3,\n.light-mode .lt-coach-tables-dialog__dest-tables-hint {\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-tables-dialog__station-move-btn {\n  background: #fff;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-tables-dialog__station-swap-btn {\n  color: #92400e;\n}\n\n.lt-coach-tables-dialog__unseated-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.lt-coach-tables-dialog__unseated-head h3 {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: color-mix(in srgb, #fde68a 70%, #f8fafc);\n}\n\n.lt-coach-tables-dialog__unseated-count {\n  min-width: 1.4rem;\n  padding: 1px 7px;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  background: color-mix(in srgb, #fbbf24 28%, transparent);\n  color: #fde68a;\n  text-align: center;\n}\n\n.lt-coach-tables-dialog__unseated-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  max-height: 88px;\n  overflow-y: auto;\n}\n\n.lt-coach-tables-dialog__unseated-list > li {\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.lt-coach-tables-dialog__unseated-btn,\n.lt-coach-tables-dialog__unseated-row {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 8px;\n  padding: 5px 10px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(15, 23, 42, 0.35);\n  color: rgba(248, 250, 252, 0.9);\n  font-size: 0.78rem;\n  line-height: 1.2;\n}\n\n.lt-coach-tables-dialog__unseated-btn {\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    transform 0.12s ease;\n}\n\n.lt-coach-tables-dialog__unseated-btn:hover {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);\n}\n\n.lt-coach-tables-dialog__unseated-btn:active {\n  transform: scale(0.98);\n}\n\n.lt-coach-tables-dialog__unseated-btn--selected {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 36%, transparent);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, transparent);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);\n}\n\n.lt-coach-tables-dialog__unseated-btn span:last-child,\n.lt-coach-tables-dialog__unseated-row span:last-child {\n  opacity: 0.72;\n  font-size: 0.7rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-coach-tables-dialog__close {\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.lt-coach-tables-dialog__seating-toolbar {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 4px;\n  flex-shrink: 0;\n  padding: 0;\n  margin: 0;\n}\n\n.lt-coach-tables-dialog__tool-expand {\n  position: relative;\n  display: inline-flex;\n  align-items: flex-start;\n  flex-shrink: 0;\n}\n\n.lt-coach-tables-dialog__tool-overlay {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 132px;\n  padding: 4px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(15, 23, 42, 0.96);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);\n}\n\n.lt-coach-tables-dialog__tool-overlay-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #f8fafc;\n  font-size: 0.78rem;\n  font-weight: 650;\n  cursor: pointer;\n  text-align: left;\n}\n\n.lt-coach-tables-dialog__tool-overlay-item:hover:not(:disabled) {\n  background: rgba(8, 119, 188, 0.28);\n}\n\n.lt-coach-tables-dialog__tool-overlay-item:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Bottom caption / voice dock — keeps action buttons free and 5-table grid stable. */\n.lt-coach-tables-dialog__footer.lt-coach-tables-dialog__caption-dock {\n  padding: 4px 10px calc(6px + env(safe-area-inset-bottom, 0px));\n  flex-shrink: 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.55);\n  z-index: 10;\n}\n\n.lt-coach-tables-dialog__caption-slot {\n  position: relative;\n  flex-shrink: 0;\n  min-height: 32px;\n  width: 100%;\n}\n\n.lt-coach-tables-dialog.lt-pingflo-caption-open .lt-coach-tables-dialog__caption-slot {\n  min-height: 52px;\n}\n\n.lt-coach-tables-dialog__seating-msg {\n  margin: 0;\n  padding: 6px 10px;\n  min-height: 32px;\n  border-radius: 8px;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 16%, transparent);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #e2e8f0;\n  font-size: 0.78rem;\n  font-weight: 600;\n  line-height: 1.3;\n  box-sizing: border-box;\n}\n\n.lt-coach-tables-dialog__seating-msg.is-empty {\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n\n.lt-coach-tables-dialog__caption-slot:has(.lt-pingflo-voice__portal) .lt-coach-tables-dialog__seating-msg {\n  display: none;\n}\n\n/* Light mode — table configuration */\n.light-mode .lt-coach-tables-dialog.lt-table-wizard {\n  background: linear-gradient(\n    165deg,\n    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 10%, #f8fafc) 0%,\n    #ffffff 55%,\n    #f1f5f9 100%\n  );\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-tables-dialog__title-row h2,\n.light-mode .lt-coach-tables-dialog__stat,\n.light-mode .lt-coach-tables-dialog__timer-value,\n.light-mode .lt-coach-tables-dialog__page-meta {\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-tables-dialog__timer-label,\n.light-mode .lt-coach-tables-dialog__stat {\n  color: #334155;\n}\n\n.light-mode .lt-coach-tables-dialog__timer {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-tables-dialog__chrome {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 4%, #f8fafc);\n  border-bottom-color: rgba(15, 23, 42, 0.08);\n}\n\n.light-mode .lt-coach-tables-dialog__tool-group {\n  background: #ffffff;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 24%, #cbd5e1);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.light-mode .lt-coach-tables-dialog__tool-group-label {\n  color: var(--lt-brand, #0877bc);\n}\n\n.light-mode .lt-coach-tables-dialog__tool-group--capture.is-armed {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, #cbd5e1);\n}\n\n.light-mode .lt-coach-tables-dialog__tool-group--capture.is-live {\n  background: #fef2f2;\n  border-color: #fca5a5;\n}\n\n.light-mode .lt-coach-tables-dialog__tool-group--capture.is-live .lt-coach-tables-dialog__tool-group-label {\n  color: #b91c1c;\n}\n\n.light-mode .lt-coach-tables-dialog__stat {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 8%, #ffffff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 24%, #cbd5e1);\n  color: #1e293b;\n}\n\n.light-mode .lt-coach-tables-dialog__stat svg {\n  color: var(--lt-brand, #0877bc);\n}\n\n.light-mode .lt-coach-tables-dialog__tool-btn {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 8%, #f8fafc);\n  border-color: transparent;\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-tables-dialog__tool-btn:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 16%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 38%, #94a3b8);\n}\n\n.light-mode .lt-coach-tables-dialog__tool-btn--active {\n  background: var(--lt-brand, #0877bc);\n  border-color: var(--lt-brand, #0877bc);\n  color: #ffffff;\n}\n\n.light-mode .lt-coach-tables-dialog__tool-btn--recording {\n  background: #dc2626;\n  border-color: #ef4444;\n  color: #ffffff;\n}\n\n.light-mode .lt-coach-tables-dialog__pingflo-mic {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #f8fafc);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 30%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-tables-dialog__stat--warn {\n  color: #b45309;\n}\n\n.light-mode .lt-coach-tables-dialog__stat--warn svg {\n  color: #d97706;\n}\n\n.light-mode .lt-coach-tables-dialog__unseated {\n  background: color-mix(in srgb, #f59e0b 10%, #fff);\n  border-color: color-mix(in srgb, #f59e0b 35%, #cbd5e1);\n}\n\n.light-mode .lt-coach-tables-dialog__unseated-head h3 {\n  color: #92400e;\n}\n\n.light-mode .lt-coach-tables-dialog__unseated-count {\n  background: color-mix(in srgb, #f59e0b 22%, #fff);\n  color: #92400e;\n}\n\n.light-mode .lt-coach-tables-dialog__unseated-btn,\n.light-mode .lt-coach-tables-dialog__unseated-row {\n  background: #fff;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-tables-dialog__unseated-btn:hover {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);\n}\n\n.light-mode .lt-coach-tables-dialog__footer.lt-coach-tables-dialog__caption-dock {\n  background: rgba(248, 250, 252, 0.92);\n  border-top-color: rgba(15, 23, 42, 0.1);\n}\n\n.light-mode .lt-coach-tables-dialog__seating-msg {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-tables-dialog__edge {\n  background: linear-gradient(\n    90deg,\n    rgba(248, 250, 252, 0.95),\n    rgba(248, 250, 252, 0)\n  );\n  color: #0f172a;\n}\n\n.light-mode .lt-coach-tables-dialog__edge--next {\n  background: linear-gradient(\n    270deg,\n    rgba(248, 250, 252, 0.95),\n    rgba(248, 250, 252, 0)\n  );\n}\n\n.lt-coach-tables-dialog__tool-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  min-width: 34px;\n  height: 34px;\n  padding: 0 7px;\n  border-radius: 9px;\n  border: 1px solid transparent;\n  background: rgba(255, 255, 255, 0.05);\n  color: #f8fafc;\n  font: inherit;\n  font-size: 0.74rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.1s ease;\n  flex-shrink: 0;\n}\n\n.lt-coach-tables-dialog__tool-btn--pill {\n  padding: 0 10px;\n}\n\n.lt-coach-tables-dialog__tool-btn-text {\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.lt-coach-tables-dialog__tool-btn-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: #f59e0b;\n  color: #0f172a;\n  font-size: 0.64rem;\n  font-weight: 800;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-coach-tables-dialog__tool-btn:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);\n}\n\n.lt-coach-tables-dialog__tool-btn--emphasis {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, rgba(255, 255, 255, 0.2));\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);\n}\n\n.lt-coach-tables-dialog__tool-btn--emphasis:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 34%, transparent);\n}\n\n/* Active configuration/seating tool (Sort, Rotate, Move): brand highlight */\n.lt-coach-tables-dialog__tool-btn--active {\n  background: var(--lt-brand, #0877bc);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #ffffff);\n  color: #ffffff;\n  box-shadow: 0 2px 10px color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);\n}\n\n/* Active live recording mode (Video / Voice): high-contrast crimson pulse */\n.lt-coach-tables-dialog__tool-btn--recording {\n  background: #dc2626;\n  border-color: #f87171;\n  color: #ffffff;\n  animation: lt-coach-recording-pulse 1.5s infinite;\n}\n\n.lt-coach-tables-dialog__tool-btn:disabled {\n  opacity: 0.42;\n  cursor: not-allowed;\n}\n\n.lt-coach-tables-dialog__capture-batch-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 34px;\n  padding: 0 10px;\n  border-radius: 9px;\n  border: 1px solid rgba(248, 113, 113, 0.55);\n  background: rgba(220, 38, 38, 0.22);\n  color: #fecaca;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.lt-coach-tables-dialog__capture-batch-btn:hover:not(:disabled) {\n  background: rgba(220, 38, 38, 0.35);\n  color: #ffffff;\n}\n\n.lt-coach-tables-dialog__capture-batch-btn--stop {\n  background: #dc2626;\n  border-color: #fca5a5;\n  color: #ffffff;\n}\n\n.lt-coach-tables-dialog__capture-batch-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.lt-coach-tables-dialog__pingflo-micro {\n  position: relative;\n  flex: 0 0 auto;\n  margin: 0;\n  min-width: 0;\n}\n\n.lt-coach-tables-dialog__pingflo-mic {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border-radius: 9px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, rgba(255, 255, 255, 0.18));\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);\n  overflow: hidden;\n  cursor: pointer;\n  color: inherit;\n}\n\n.lt-coach-tables-dialog__pingflo-mic:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.lt-coach-tables-dialog__pingflo-mark {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.lt-table-wizard__voice--micro .lt-table-wizard__voice-box--popover {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 20;\n  width: min(320px, calc(100vw - 32px));\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);\n}\n\n.lt-table-wizard__voice--micro .lt-table-wizard__banner {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 19;\n  width: min(280px, calc(100vw - 32px));\n  border-radius: 10px;\n  padding: 8px 10px;\n  margin: 0;\n  font-size: 0.72rem;\n}\n\n.lt-table-wizard__voice-portal {\n  position: fixed;\n  inset: 0;\n  z-index: 1600;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 16px;\n  padding-bottom: max(16px, env(safe-area-inset-bottom));\n  background: rgba(8, 15, 28, 0.55);\n  box-sizing: border-box;\n}\n\n.lt-table-wizard__voice-box--portal {\n  width: min(420px, 100%);\n  margin: 0;\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.5);\n}\n\n.lt-table-wizard__voice-examples {\n  margin: 0 0 8px;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: rgba(248, 250, 252, 0.7);\n}\n\n.lt-coach-tables-dialog__seating-msg.lt-coach-tables-dialog__recording-hint {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #fcd34d;\n  font-weight: 700;\n  background: rgba(251, 191, 36, 0.12);\n  border-color: rgba(251, 191, 36, 0.35);\n}\n\n.lt-coach-tables-dialog__seating-msg.lt-coach-tables-dialog__recording-hint--live {\n  color: #fca5a5;\n  background: rgba(239, 68, 68, 0.14);\n  border-color: rgba(239, 68, 68, 0.45);\n}\n\n.light-mode .lt-coach-tables-dialog__seating-msg.lt-coach-tables-dialog__recording-hint {\n  color: #92400e;\n  background: #fef3c7;\n  border-color: #fcd34d;\n}\n\n.light-mode .lt-coach-tables-dialog__seating-msg.lt-coach-tables-dialog__recording-hint--live {\n  color: #b91c1c;\n  background: #fee2e2;\n  border-color: #fca5a5;\n}\n\n@keyframes lt-coach-recording-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.45);\n  }\n  50% {\n    box-shadow: 0 0 0 8px rgba(211, 47, 47, 0);\n  }\n}\n\n.lt-coach-tables-dialog__progress {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  flex-shrink: 0;\n}\n\n.lt-coach-tables-dialog__progress-label {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #f8fafc;\n}\n\n.lt-coach-tables-dialog__progress-done {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.74rem;\n  font-weight: 700;\n  color: #86efac;\n}\n\n.lt-coach-tables-dialog__status-pill {\n  display: inline-flex;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: rgba(56, 189, 248, 0.16);\n  border: 1px solid rgba(56, 189, 248, 0.35);\n  color: #7dd3fc;\n}\n\n.lt-coach-dash__kot-done {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: #86efac;\n}\n\n/* Swipe pages of tables sized to the available viewport */\n.lt-coach-tables-dialog__body {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.lt-coach-tables-dialog__pager {\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  align-items: stretch;\n}\n\n.lt-coach-tables-dialog__pages {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scroll-snap-type: x mandatory;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.lt-coach-tables-dialog__pages::-webkit-scrollbar {\n  display: none;\n}\n\n.lt-coach-tables-dialog__page {\n  flex: 0 0 100%;\n  width: 100%;\n  height: 100%;\n  scroll-snap-align: start;\n  scroll-snap-stop: always;\n  padding: 0 28px;\n  box-sizing: border-box;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n.lt-coach-tables-dialog__grid {\n  display: grid;\n  grid-template-columns: repeat(var(--lt-tables-cols, 1), minmax(0, 1fr));\n  /* Size each row to its card content so 2-player tables stay compact */\n  grid-template-rows: repeat(var(--lt-tables-rows, 5), auto);\n  gap: 5px;\n  width: 100%;\n  min-height: 0;\n  height: auto;\n  align-content: start;\n  box-sizing: border-box;\n}\n\n.lt-coach-tables-dialog__grid > .lt-coach-table,\n.lt-coach-tables-dialog__grid > .lt-table-wizard__card {\n  height: auto;\n  min-height: 0;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 5px 7px;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 32%, rgba(255, 255, 255, 0.12));\n}\n\n.lt-coach-tables-dialog__grid > .lt-coach-table--multi,\n.lt-coach-tables-dialog__grid > .lt-coach-table--has-classement.lt-coach-table--multi {\n  height: auto;\n  min-height: 0;\n  justify-content: flex-start;\n  padding: 6px 8px;\n  overflow: visible;\n}\n\n/* Dual A-vs-B cards: keep the tight pre-multi footprint */\n.lt-coach-tables-dialog__grid > .lt-coach-table:not(.lt-coach-table--multi) {\n  padding: 5px 7px;\n}\n\n.lt-coach-tables-dialog__grid > .lt-coach-table--slot-empty {\n  min-height: 0;\n  height: 100%;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.lt-coach-tables-dialog__edge {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 3;\n  width: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: none;\n  background: linear-gradient(\n    90deg,\n    rgba(15, 23, 42, 0.88),\n    rgba(15, 23, 42, 0)\n  );\n  color: #f8fafc;\n  cursor: pointer;\n}\n\n.lt-coach-tables-dialog__edge--prev {\n  left: 0;\n}\n\n.lt-coach-tables-dialog__edge--next {\n  right: 0;\n  background: linear-gradient(\n    270deg,\n    rgba(15, 23, 42, 0.88),\n    rgba(15, 23, 42, 0)\n  );\n}\n\n.lt-coach-tables-dialog__edge:disabled {\n  opacity: 0.22;\n  cursor: default;\n}\n\n.lt-coach-tables-dialog__edge:not(:disabled):active {\n  color: var(--lt-brand, #0877bc);\n}\n\n.lt-coach-tables-dialog__page-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: rgba(248, 250, 252, 0.7);\n  flex-shrink: 0;\n}\n\n.lt-coach-tables-dialog__dots {\n  display: inline-flex;\n  gap: 6px;\n}\n\n.lt-coach-tables-dialog__dot {\n  width: 8px;\n  height: 8px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: rgba(248, 250, 252, 0.28);\n  cursor: pointer;\n}\n\n.lt-coach-tables-dialog__dot--on {\n  transform: scale(1.2);\n}\n\n.lt-coach-tables-dialog__footer {\n  padding: 8px 12px 10px;\n  flex-shrink: 0;\n}\n\n/* Leave room handled by footer dock itself — do not pad extra under actions. */\n.lt-coach-tables-dialog.lt-pingflo-caption-open .lt-coach-tables-dialog__footer {\n  padding-bottom: calc(6px + env(safe-area-inset-bottom, 0px));\n}\n\n@media (max-width: 520px) {\n  .lt-coach-tables-dialog.lt-table-wizard {\n    width: 100%;\n    border-radius: 12px;\n  }\n\n  .lt-coach-tables-dialog__header {\n    flex-wrap: wrap;\n  }\n\n  .lt-coach-tables-dialog__header-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .lt-coach-tables-dialog__page {\n    padding: 0 24px;\n  }\n\n  .lt-coach-tables-dialog__grid > .lt-coach-table,\n  .lt-coach-tables-dialog__grid > .lt-table-wizard__card {\n    min-height: 64px;\n  }\n}\n\n/* Landscape: use horizontal space — 2-column grid, compact chrome */\n@media (orientation: landscape) {\n  .lt-coach-tables-dialog__backdrop {\n    padding: 6px;\n    padding-bottom: var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));\n  }\n\n  .lt-coach-tables-dialog.lt-table-wizard {\n    width: min(920px, 100%);\n    height: calc(\n      var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 12px -\n        env(safe-area-inset-top, 0px)\n    );\n    max-height: calc(\n      var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 12px -\n        env(safe-area-inset-top, 0px)\n    );\n  }\n\n  .lt-coach-tables-dialog__header {\n    padding: 6px 10px;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .lt-coach-tables-dialog__header-main {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px 14px;\n  }\n\n  .lt-coach-tables-dialog__title-row h2 {\n    font-size: 0.92rem;\n  }\n\n  .lt-coach-tables-dialog__stats {\n    margin-top: 0;\n    gap: 8px;\n  }\n\n  .lt-coach-tables-dialog__timer {\n    margin-top: 0;\n    padding: 4px 8px;\n    min-width: 72px;\n    flex-direction: row;\n    align-items: baseline;\n    gap: 8px;\n  }\n\n  .lt-coach-tables-dialog__timer-label {\n    font-size: 0.6rem;\n  }\n\n  .lt-coach-tables-dialog__timer-value {\n    font-size: 1.1rem;\n  }\n\n  .lt-coach-tables-dialog__tool-btn,\n  .lt-coach-tables-dialog__pingflo-mic {\n    min-width: 34px;\n    height: 34px;\n  }\n\n  .lt-coach-tables-dialog__tool-btn--pill {\n    width: auto;\n  }\n\n  .lt-coach-tables-dialog .lt-table-wizard__body {\n    padding: 4px 10px;\n  }\n\n  .lt-coach-tables-dialog__grid {\n    gap: 6px;\n  }\n\n  .lt-coach-tables-dialog__page {\n    padding: 0 22px;\n  }\n\n  .lt-coach-tables-dialog__page-meta {\n    margin-top: 4px;\n    padding-top: 4px;\n  }\n\n  .lt-coach-tables-dialog__footer {\n    padding: 6px 10px 8px;\n  }\n\n  .lt-coach-tables-dialog__progress {\n    padding: 4px 10px;\n  }\n}\n\n@media (orientation: landscape) and (max-height: 520px) {\n  .lt-coach-tables-dialog.lt-table-wizard {\n    height: calc(\n      var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 8px -\n        env(safe-area-inset-top, 0px)\n    );\n    max-height: calc(\n      var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 8px -\n        env(safe-area-inset-top, 0px)\n    );\n  }\n\n  .lt-coach-tables-dialog__header {\n    padding: 4px 8px;\n  }\n\n  .lt-coach-tables-dialog__title-row h2 {\n    font-size: 0.85rem;\n  }\n\n  .lt-coach-tables-dialog__stat {\n    font-size: 0.68rem;\n  }\n\n  .lt-coach-tables-dialog__grid {\n    gap: 4px;\n  }\n\n  .lt-coach-tables-dialog__recording-hint {\n    padding: 3px 8px;\n    font-size: 0.7rem;\n  }\n\n  .lt-coach-tables-dialog__grid > .lt-coach-table,\n  .lt-coach-tables-dialog__grid > .lt-table-wizard__card {\n    min-height: 56px;\n    padding: 6px 8px;\n  }\n\n  .lt-coach-tables-dialog__footer {\n    padding: 6px 10px 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
